import { defineMessages } from 'react-intl';

export const texts = defineMessages({
  clear: {
    id: 'FilterDateRange.clear',
    description: 'Clear date range filter',
    defaultMessage: 'Rensa',
  },
});
